export const CategoryRouting = [
  {
    path: "/material/category/list",
    name: "basic-material-category-list",
    meta: { title: "材料分类" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-category" */ "@/views/material/category/list/index.vue"
      ),
  },
];
